import { IGlobalState } from '../../../Root/store/appReducer'

export const getUserActivitiesList = (state: IGlobalState) => state.activities.list
export const getUserActivitiesLoading = (state: IGlobalState) => state.activities.isLoading
export const getUserActivitiesHasLoaded = (state: IGlobalState) => state.activities.hasLoaded || false

// New selectors for infinite scroll
export const getActivitiesLoadingMore = (state: IGlobalState) => state.activities.isLoadingMore
export const getActivitiesHasMore = (state: IGlobalState) => state.activities.hasMore
export const getActivitiesOffset = (state: IGlobalState) => state.activities.offset

// Lazily loaded routes. Defaults guard against a persisted pre-feature `activities` slice.
export const getRoutesById = (state: IGlobalState) => state.activities.routesById || {}
export const getRouteLoadingIds = (state: IGlobalState) => state.activities.routeLoadingIds || {}

// Review duplicates modal selectors. Defaults guard against a persisted `activities` slice from
// before this feature existed (redux-persist rehydration would otherwise leave these undefined).
export const getReviewModalOpen = (state: IGlobalState) => state.activities.reviewModalOpen || false
export const getDuplicates = (state: IGlobalState) => state.activities.duplicates || []
export const getDuplicatesMainId = (state: IGlobalState) => state.activities.reviewMainId || null
export const getDuplicatesLoading = (state: IGlobalState) => state.activities.duplicatesLoading || false
export const getSettingMain = (state: IGlobalState) => state.activities.settingMain || false
